import { render, staticRenderFns } from "./ziliao.vue?vue&type=template&id=f3af444e"
import script from "./ziliao.vue?vue&type=script&lang=js"
export * from "./ziliao.vue?vue&type=script&lang=js"
import style0 from "./ziliao.vue?vue&type=style&index=0&id=f3af444e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports